invHdApp.controller('RouteListController', ['$scope', 'RouteList', 'Route', '$location', '$routeParams', '$filter', '$rootScope', 'Order', '$translate',
  function ($scope, RouteList, Route, $location, $routeParams, $filter, $rootScope, Order, $translate) {
    $scope.deleted = [];

    $scope.editSort = false;
    $scope.models = {
      selected: null
    };

    $scope.saveSort = function () {
      console.log($scope.route.orders);
      if (confirm('Bu rotanın sıralaması değiştirilecektir, onaylıyor musunuz ?')) {
        Route.updateSort({
          route_id: $scope.route.id,
          orders: $scope.route.orders
        }).success(function (data, status, headers, config) {
          $scope.editSort = false;
          Messenger().post('Rota sıralaması başarıyla değiştirildi!');
        }).error(function (data) {
          alert(data.message);
        });
      } else {
        $scope.route.worker_id = 0;
      }
    }

    $scope.setEditSort = function () {
      $scope.editSort = !$scope.editSort;
    }

    $scope.printBulkRoute = function (route) {
      var ids = route.orders.map(order => order.id).join(',');

      // Company 51 (Fupa): yeni 10x10 barkod; MTN (87): fast-barcode
      var url = '/print-pdf-order/' + ids + '?bulk=true';
      if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 51) {
        url = '/print-new-barcode/' + ids + '?bulk=true';
      } else if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 87) {
        url = '/print-fast-barcode-order/' + ids + '?bulk=true';
      }
      
      var newwindow = window.open(url, 'Print Order', 'width=700, height=470');
      if (window.focus) {
        newwindow.focus()
      }
      return false;
    }


    $scope.selectAll = function (select) {
      if (select) {
        $scope.deleted = [];
        for (let i = 0; i < $scope.data.routes.data.length; i++) {
          $scope.deleted.push($scope.data.routes.data[i].id);
        }
      } else {
        $scope.deleted = [];
      }
    };

    $scope.oldRoute = {};

    $scope.changeWorker = function () {
      if (confirm('Bu rotanın sahibi değiştirilecektir, onaylıyor musunuz ?')) {
        Route.assignToWorker({
          worker_id: $scope.route.worker.id,
          route_id: $scope.route.id
        }).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
          $scope.all();
        }).error(function (data) {
          $scope.route.worker = $scope.oldRoute.worker;
          alert(data.message);
        });
      } else {
        $scope.route.worker_id = 0;
      }
    }

    $scope.changeRouteStatus = function () {
      if (confirm('Bu rotanın durumu değiştirilecektir, onaylıyor musunuz ?')) {
        Route.changeRouteStatus({
          status: $scope.route.status,
          route_id: $scope.route.id
        }).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
          $scope.all();
        }).error(function (data) {
          $scope.route.status = $scope.oldRoute.status;
          alert(data.message);
        });
      } else {
        $scope.route.status = $scope.oldRoute.status;
      }
    }

    $scope.changeItem = function (type, code, status, item) {
      if (confirm('Durum değiştirilecektir, onaylıyor musunuz ?')) {
        RouteList.changeItem({
          type: type,
          code: code,
          status: status
        }).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
        }).error(function (data) {
          alert('Error');
        });
      } else {
        item[type] = !status;
        $scope.route.worker_id = 0;
      }
    }

    $scope.readAll = function (type, id, field, route_id) {
      if (confirm($translate.instant("ARE_U_SURE_DELETE"))) {
        RouteList.readAll({
          type: type,
          id: id,
          field: field
        }).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
          RouteList.get(route_id).success(function (data, status, headers, config) {
            $scope.route = data.route;
            $scope.oldRoute = data.route;
            $scope.steps = data.steps;
          });
        }).error(function (data) {
          alert('Error');
        });
      } else {
        item[type] = !status;
        $scope.route.worker_id = 0;
      }
    }

    $scope.changeStatus = function (order, oldStatus) {
      if (confirm('Durum değiştirilecektir, onaylıyor musunuz ?')) {
        Order.changeWorkStatus(order).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
        });
      } else {
        order.status = oldStatus;
      }
    }

    $scope.updateBarcode = function () {
      if (confirm('Bu rotanin barkodu değişecektir, onaylıyor musunuz ?')) {
        RouteList.updateBarcode($scope.route).success(function (data, status, headers, config) {
          Messenger().post('Barkod Güncellendi');
        });
      }
    }

    $scope.changeArrived = function (order, oldArrived) {
      if (confirm('Durum değiştirilecektir, onaylıyor musunuz ?')) {
        Order.changeArrived({ order_id: order.id, arrived: order.arrived }).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
        });
      } else {
        order.arrived = oldArrived;
      }
    }

    $scope.filterData = {
      station_id: [],
      price: '',
      vehicle: [],
      workers: [],
      page: 1,
      date: {
        startDate: null,
        endDate: null
      }
    }

    $scope.clearFilter = function (page) {
      $scope.filterData = {
        station_id: [],
        price: '',
        vehicle: [],
        workers: [],
        page: 1,
        date: {
          startDate: null,
          endDate: null
        }
      }
      $('.selectpicker').selectpicker('val', []);
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing map...')
      $scope.all();
    }, true);

    $scope.all = function () {
      if ($routeParams.worker_id) {
        $scope.filterData.workers.push($routeParams.worker_id);
      }
      if ($routeParams.route_id) {
        $scope.openDetail($routeParams.route_id);
        // return true;
      }
      RouteList.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.$on('new_data', function () {
      $scope.new();
      $('#newRoute').modal('show');
    }, true);

    $scope.$on('edit_data', function () {
      $scope.editWorker(data);
      $('#newRoute').modal('show');
    }, true);

    $scope.editRoute = function (route) {
      $rootScope.route = route;
      $rootScope.route.date = moment(route.scheduled_start).format('YYYY-MM-DD');
      $rootScope.route.scheduled_start = moment(route.scheduled_start).format('hh:mm');
      $rootScope.route.scheduled_end = moment(route.scheduled_end).format('hh:mm');
      $('#newRoute').modal('show');
      $('#routesDetail').modal('hide');
      RouteList.new().success(function (data, status, headers, config) {
        $rootScope.stations = data.stations;
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
        jQuery('#start').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        });
        jQuery('#end').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        })
      });
    }
    $scope.getTodayRouteCount = function() {
      if (!$scope.data || !$scope.data.routes || !$scope.data.routes.data) {
          return 0;
      }
      
      var today = moment().format('DD/MM/YYYY');
      return $scope.data.routes.data.filter(function(route) {
          return moment(route.scheduled_start).format('DD/MM/YYYY') === today
              && route.order_count > 0;
      }).length;
    };

    $scope.getTodayCompletedCount = function() {
      if (!$scope.data || !$scope.data.routes || !$scope.data.routes.data) {
          return 0;
      }
      
      var today = moment().format('DD/MM/YYYY');
      return $scope.data.routes.data.filter(function(route) {
          return moment(route.scheduled_start).format('DD/MM/YYYY') === today 
              && route.order_count > 0 
              && route.completed_order_count === route.order_count;
      }).length;
    };

    $scope.getTodayTotalPoints = function() {
      if (!$scope.data || !$scope.data.routes || !$scope.data.routes.data) {
          return 0;
      }
      
      var today = moment().format('DD/MM/YYYY');
      return $scope.data.routes.data.reduce(function(total, route) {
          if (moment(route.scheduled_start).format('DD/MM/YYYY') === today) {
              return total + (route.order_count || 0);
          }
          return total;
      }, 0);
    };

    $scope.getTodayRemainingPoints = function() {
      if (!$scope.data || !$scope.data.routes || !$scope.data.routes.data) {
          return 0;
      }
      
      var today = moment().format('DD/MM/YYYY');
      return $scope.data.routes.data.reduce(function(remaining, route) {
          if (moment(route.scheduled_start).format('DD/MM/YYYY') === today) {
              return remaining + ((route.order_count || 0) - (route.completed_order_count || 0));
          }
          return remaining;
      }, 0);
    };

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.all();
    }

    $scope.get = function () {
      RouteList.get($routeParams.id).success(function (data, status, headers, config) {
        $scope.data = data;
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
        jQuery('#start').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        });
        jQuery('#end').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        });
      });
    }

    $scope.new = function () {
      RouteList.new().success(function (data, status, headers, config) {
        $rootScope.stations = data.stations;
        $scope.route = {
          scheduled_start: '10:00',
          scheduled_end: '14:00',
        }
        $rootScope.route = {
          scheduled_start: '10:00',
          scheduled_end: '14:00',
        }
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
        jQuery('#start').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        });
        jQuery('#end').datetimepicker({
          format: 'H:i',
          formatTime: 'H:i',
          datepicker: false,
          step: 30,
        })
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        RouteList.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.routes.data.indexOf($filter('filter')($scope.data.routes.data, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1)
              $scope.data.routes.data.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $rootScope.saveRoute = function (route) {
      if (route.id) {
        $scope.update();
      } else {
        RouteList.save(route).success(function (data, status, headers, config) {
          $scope.data = data;
          setTimeout(() => {
            $scope.$apply()
          }, 300);
          Messenger().post(data.message);
          $('#newRoute').modal('hide');
          $scope.getRoutes()
          $scope.$broadcast('refresh_data');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.update = function () {
      RouteList.update($scope.route).success(function (data, status, headers, config) {
        $scope.data = data;
        $scope.openDetail(data.data)
        Messenger().post(data.message);
        $('#newRoute').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.openDetail = function (route, tab = true) {
      // if (tab) {
      //   var url = 'routes?route_id=' + route.id;
      //   if ($scope.filterData.term) {
      //     url += '&term=' + $scope.filterData.term;
      //   }
      //   if ($scope.filterData.qr) {
      //     url += '&qr=' + $scope.filterData.qr;
      //   }
      //   window.open(url, '_blank');
      //   return true;
      // }

      $scope.orderMarkers = [];
      $scope.orderMarkerInfos = [];
      $scope.objectManager = null; // ObjectManager'ı sıfırla

      RouteList.get(route && route.id ? route.id : route).success(function (data, status, headers, config) {
        $('#routesDetail').modal('show');
        $scope.route = data.route;
        $scope.workers = data.workers;
        $scope.oldRoute = data.route;
        $scope.steps = data.steps;
        if (tab) {
          $('.rtstops').click();
        }

        document.getElementById('mapArea').innerHTML = '<div id="routeMap" style="width:100%;height:100vh;"></div>';
        $scope.map = new ymaps.Map('routeMap', {
          center: [38.7267005, 35.2151109],
          zoom: 6,
          controls: ['fullscreenControl'],
          balloonMaxWidth: 300,
          balloonPanelMaxMapArea: 0
        });

        const routesDetail = document.getElementById('routesDetail');
        const mapContainer = routesDetail?.querySelector('#mapArea');
        mapContainer.style.zoom = 1.15;

        const printContentDiv = routesDetail?.querySelector('#print-content');
        printContentDiv.style.height = '118vh';

        $scope.orderMarkers = [];
        $scope.orderMarkerInfos = [];

        // Order Markers
        $scope.route.orders.forEach((element, i) => {
          $scope.createOrderMarker(element, i);
        });

        var boundMarkers = $scope.orderMarkers;

        // Worker Markers
        if ($scope.route.worker) {
          $scope.createWorkerMarker($scope.route.worker);
        }

        // Station Markers
        // if ($scope.route.station) {
        //   var icon = L.icon({
        //     iconUrl: "/img/map-pin-red.svg",
        //     iconSize: [48, 48],
        //   });

        //   var content = '<div id="iw-container">' +
        //     '<div class="iw-content"> ' +
        //     '<strong>#' + $scope.route.station.name + '</strong></div></div>';

        //   var stationMarker = L.marker([Number($scope.route.station.latitude), Number($scope.route.station.longitude)], {
        //     icon: icon
        //   })
        //     .addTo($scope.map)
        //     .bindPopup(content);
        //   boundMarkers.push(stationMarker);
        // }

        $scope.fitBounds($scope.orderMarkers);
        // $scope.map.fitBounds(group.getBounds());

        // renderRoute($scope.route, '#FF6633');

        $scope.searchTerms = '';
        $scope.searchIdTerms = '';
        if ($routeParams.term) {
          $scope.searchIdTerms = $routeParams.term;
        }
        if ($routeParams.qr) {
          $scope.searchTerms = $routeParams.qr;
        }

      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.fitBounds = function (markers) {
      if (!markers || !Array.isArray(markers) || markers.length === 0 || !$scope.map) {
        return;
      }

      try {
        // Koordinatları topla
        var coordinates = [];
        markers.forEach(function (marker) {
          if (marker && marker.geometry) {
            var coords = marker.geometry.getCoordinates();
            if (Array.isArray(coords) && coords.length === 2 &&
              !isNaN(coords[0]) && !isNaN(coords[1])) {
              coordinates.push(coords);
            }
          }
        });

        if (coordinates.length === 0) {
          return;
        }

        // Minimum ve maksimum koordinatları bul
        var minLat = Math.min.apply(null, coordinates.map(function (c) { return c[0]; }));
        var maxLat = Math.max.apply(null, coordinates.map(function (c) { return c[0]; }));
        var minLng = Math.min.apply(null, coordinates.map(function (c) { return c[1]; }));
        var maxLng = Math.max.apply(null, coordinates.map(function (c) { return c[1]; }));

        // Bounds'ı ayarla
        $scope.map.setBounds([[minLat, minLng], [maxLat, maxLng]], {
          checkZoomRange: true,
          duration: 500,
          zoomMargin: 50
        }).then(function () {
          var currentZoom = $scope.map.getZoom();
          if (currentZoom > 15) {
            $scope.map.setZoom(15);
          }
        });
      } catch (e) {
        console.error('Error fitting bounds:', e);
      }
    };

    $scope.zoomIn = function (lat, lng) {
      if (!$scope.map || !lat || !lng) return;

      try {
        $scope.map.setCenter([lat, lng], 16, {
          duration: 500 // Animasyon süresi (ms)
        });
      } catch (e) {
        console.error('Error zooming to location:', e);
      }
    };

    $scope.createOrderMarker = function (order, index) {
      if (order.location) {
        var location = [Number(order.location.latitude), Number(order.location.longitude)];

        // Marker HTML içeriği
        var html = '<div class="map-marker"><img src="/img/icons/continue.png" alt="" width="30px">';
        if (order.status && order.status.value == 'complete') {
          html = '<div class="map-marker map-marker-success"><img src="/img/icons/complete.png" alt="" width="30px">';
        } else if (order.status && order.status.value == 'fail') {
          html = '<div class="map-marker"><img src="/img/icons/fail.png" alt="" width="30px">';
        }
        html += '<strong class="map-index">' + (index + 1) + '</strong></div>';

        // Balloon içeriği
        var content = '<div id="iw-container">' +
          '<div class="iw-content"> ' +
          '<strong>#' + order.id + '</strong>';
        if (order.special_value) {
          content += ' - <strong>' + order.special_value + '</strong>';
        }
        content += '<hr style="margin:17px 0">' +
          '<p>' + order.customer.customer_name + ' </p>' +
          '<p>' + order.location.name + '</p>' +
          '<p>' + order.location.address + '</p>' +
          '<div class="row"><div class="col-md-6 pull-left">' +
          '<a href="javascript:void(0)" onclick="angular.element(this).scope().zoomIn(' + order.location.latitude + ',' + order.location.longitude + ')" class="gk-button blue btn-xs"><i class="fa fa-search-plus"></i></a> </div>' +
          '<div class="col-md-6 pull-left"><a href="javascript:void(0)" onclick="angular.element(this).scope().getOrderDetails(' + order.id + ')" class="gk-button blue btn-xs pull-right"><i class="fa fa-eye"></i></a> </div></div>';
        if (order.worker) {
          content += '<p>' + order.worker.full_name + '</p>';
        }
        content += '</div></div>';

        // Marker oluşturma
        var marker = new ymaps.Placemark(location, {
          balloonContentBody: content
        }, {
          // Marker style options
          iconLayout: 'default#imageWithContent',
          iconImageHref: 'transparent.png',
          iconImageSize: [30, 30],
          iconImageOffset: [-15, -15],
          iconContentLayout: ymaps.templateLayoutFactory.createClass(html),
          // Balloon options
          balloonMaxWidth: 300,
          balloonMinWidth: 200,
          hideIconOnBalloonOpen: false,
          balloonOffset: [0, -40],
          balloonCloseButton: true,
          balloonPanelMaxMapArea: 0
        });

        $scope.map.geoObjects.add(marker);

        marker.events.add('click', function (e) {
          console.log('marker tıklandı');
          if (!($scope.can('customer') && $scope.authenticatedUser.customer_id != order.company_customer_id)) {
            // Diğer tüm balonları kapat
            $scope.orderMarkers.forEach(function (m) {
              if (m !== marker) {
                m.balloon.close();
              }
            });

            // Bu marker'ın balonunu aç
            if (!marker.balloon.isOpen()) {
              marker.balloon.open();
            }

            // Scope'u güncelle
            if (!$scope.$$phase) {
              $scope.$apply();
            }
          }
          e.stopPropagation();
        });

        $scope.orderMarkers.push(marker);
        $scope.orderMarkerInfos[order.id] = marker;
      }
    };

    $scope.createWorkerMarker = function (worker) {
      if (worker.lat.length == 0 || worker.lon.length == 0) {
        return;
      }

      var location = [Number(worker.lat), Number(worker.lon)];
      var html = '<div class="map-worker-marker"><img src="/img/icons/worker.png" alt="" width="30px"></div>';

      if ($scope.workerMarker) {
        $scope.workerMarker.geometry.setCoordinates(location);
        $scope.workerMarker.properties.set('balloonContent', infoWindow(worker));
        return;
      }

      $scope.workerMarker = new ymaps.Placemark(location, {
        balloonContent: infoWindow(worker)
      }, {
        iconLayout: 'default#imageWithContent',
        iconImageHref: 'transparent.png',
        iconImageSize: [30, 30],
        iconImageOffset: [-15, -15],
        iconContentLayout: ymaps.templateLayoutFactory.createClass(html)
      });

      $scope.map.geoObjects.add($scope.workerMarker);
      $scope.orderMarkers.push($scope.workerMarker);
    };

    function infoWindow(data) {
      try {
        var extra = angular.fromJson(data.location_info);
      } catch (error) {
        var extra = {
          accuracy: '-',
          timestamp: '-',
        };
      }
      return '<div id="iw-container">' +
        '<div class="iw-content">' +
        '<div class="iw-subTitle" style="display: contents;">' + data.full_name + '</div>' +
        '<img src="https://s3.eu-central-1.amazonaws.com/herodispatcher/' + data.profile_photo + '" class="img-circle" height="44" width="44">' +
        '<p><strong> Accuary : </strong>' + Math.round(extra.accuracy) + ' Meter</p>' +
        '<p><strong> Last Location Update : </strong>' + moment(extra.timestamp).format('D MMM, HH:mm') + '</p>' +
        '</div></div>';
    }

    $scope.$on('location_update', function (event, data, nextParams, fromState) {
      if ($scope.route.worker) {
        if (data.worker.id == $scope.route.worker.id) {
          $scope.route.worker = data.worker;
          $scope.createWorkerMarker(data.worker);
        }
      }
    });

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    $scope.printRoute = function (route) {
      window.open('print-route/[' + route.id + ']', '_blank');
    };

    $scope.addOrderData = {}
    $scope.addOrder = function () {
      $scope.addOrderData.route_optimization_id = $scope.route.id
      Order.addRouteOrder($scope.addOrderData).success(function (data, status, headers, config) {
        $scope.addOrderData.code = null
        Messenger().post(data.message);
        $scope.openDetail($scope.route, false);
        successSound.play()
      }).error(function (data) {
        $scope.addOrderData.code = null
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    };

    $scope.getRouteStatus = function(start, end) {
        var now = moment();
        var currentTime = now.hours() * 60 + now.minutes();
        var startTime = moment(start).hours() * 60 + moment(start).minutes();
        var endTime = moment(end).hours() * 60 + moment(end).minutes();
        
        if (currentTime >= startTime && currentTime <= endTime) {
            return 'route-progress route-progress-current';
        }
        
        return 'route-progress route-progress-future';
    };
    $scope.getRandomVehicle = function() {
      var vehicles = ['drone.png', 'kamyon.png', 'motor.png'];
      return vehicles[Math.floor(Math.random() * vehicles.length)];
  };

  $scope.getDotArray = function(count) {
    return new Array(parseInt(count || 0));
  };

  $scope.getVehiclePosition = function(item) {
    if (!item.completed_order_count || item.completed_order_count === 0) {
        return 'calc(0% - 20px)';  
    }
    
    if (item.completed_order_count >= item.order_count) {
        return 'calc(100% - 44px)';  
    }
    

    var percentage = (item.completed_order_count / item.order_count) * 100;
    var position = Math.min(Math.max(percentage, 0), 100);
    return 'calc(' + position + '% - 44px)';  
  };

}
]);